// @ts-nocheck
import React, { Component } from 'react'

export class SubTitle extends Component {
  render() {
    const { subTitle } = this.props

    return (
      <div>
        <div style={styles.topContainer}>
          <h2 style={styles.title}>{subTitle}</h2>
        </div>
      </div>
    )
  }
}

export default SubTitle

const styles = {
  topContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: 30
  },
  title: {
    fontWeight: 'bold',
    fontSize: 18,
    marginBottom: 0
  }
}
